import { useRef, memo } from 'react';
import type { AriaTextFieldProps } from 'react-aria';
import { useTextField } from 'react-aria';



export interface TextAreaProps extends AriaTextFieldProps {
	required?: boolean,
	rounded?: boolean,
}


const TextField = (props: TextAreaProps): JSX.Element => {
	const { required = false, rounded = false, ...otherProps } = props;
	
	let ref = useRef(null);
	
	let { labelProps, inputProps, descriptionProps, errorMessageProps } = useTextField({ ...otherProps, inputElementType: 'textarea' }, ref);

	return (
		<div className='component-text-area'>

			<label {...labelProps} className='text-area-label'>
				{props.label} {required ? <span>*</span> : ''}
			</label>
			
			<textarea {...inputProps} ref={ref} className={`text-area-input${rounded ? ' rounded' : ''}`} />
		
			{props.errorMessage &&
				<div {...errorMessageProps} className={`text-area-error${rounded ? ' rounded' : ''}`}>
					{props.errorMessage}
				</div>}

			{props.description && 
				<div {...descriptionProps} className='text-area-description'>
					{props.description}
				</div>}
		</div>
	)
}


export default memo(TextField);